var _path, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormWeightIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_707_6586",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0827 1.66666H2.91602C2.5845 1.66666 2.26655 1.79835 2.03213 2.03277C1.79771 2.26719 1.66602 2.58514 1.66602 2.91666V17.0833C1.66602 17.4148 1.79771 17.7328 2.03213 17.9672C2.26655 18.2016 2.5845 18.3333 2.91602 18.3333H17.0827C17.4142 18.3333 17.7321 18.2016 17.9666 17.9672C18.201 17.7328 18.3327 17.4148 18.3327 17.0833V2.91666C18.3327 2.58514 18.201 2.26719 17.9666 2.03277C17.7321 1.79835 17.4142 1.66666 17.0827 1.66666Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.93915C6.38528 6.27248 8.05194 5.43915 10 5.43915C11.9478 5.43915 13.6144 6.27248 15 7.93915",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.9167C10.3315 12.9167 10.6495 12.785 10.8839 12.5505C11.1183 12.3161 11.25 11.9982 11.25 11.6667C11.25 11.3351 11.1183 11.0172 10.8839 10.7828C10.6495 10.5484 10.3315 10.4167 10 10.4167C9.66848 10.4167 9.35054 10.5484 9.11612 10.7828C8.8817 11.0172 8.75 11.3351 8.75 11.6667C8.75 11.9982 8.8817 12.3161 9.11612 12.5505C9.35054 12.785 9.66848 12.9167 10 12.9167Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91602 8.75L10.0027 11.6667",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_707_6586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormWeightIcon2);
export default __webpack_public_path__ + "static/media/formWeightIcon2.4f66734457670d092e042bf3f1c0f81b.svg";
export { ForwardRef as ReactComponent };